import { RouteRecordRaw } from 'vue-router'
import Layout from '@/layout/Index.vue'

const StampdutyRouter: Array<RouteRecordRaw> = [
  {
    path: '/stampduty',
    component: Layout,
    redirect: '/stampduty/index',
    children: [
      {
        path: 'index',
        component: () => import(/* webpackChunkName: "guide" */ '@/views/stampduty/index.vue'),
        name: 'Stampduty',
        meta: {
          title: 'Stampduty',
          icon: '#iconguide'
        }
      }
    ]
  }
]

export default StampdutyRouter
